import { ContactDetailsFormValues } from "./types";

export const MAX_CONTACT_EMAIL_LENGTH = 200;
export const MAX_CONTACT_NAME_LENGTH = 100;
export const MAX_CONTACT_PHONE_NUMBER_LENGTH = 20;

export const EMPTY_CONTACT_DETAILS_FORM_VALUES: ContactDetailsFormValues = {
  name: "",
  email: "",
  phone: "",
};
